import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalRolePersonService {

  constructor(private httpClientService: HttpClientService) { }

  async getGlobalRolePerson(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.GlobalRolePerson,
    }, id);
    return await firstValueFrom(observable);
  }

  async createGlobalRolePerson(personId,roleIds:number[]){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.GlobalRolePerson
    },{
      personId:personId,
      globelRoleIds:roleIds
    });
    return await firstValueFrom(observable);
  }

}